export default "__VITE_ASSET__e65649bb__"